import VueTypes from 'vue-types';

import { mapGetters, mapMutations } from 'vuex';

import 'vue-slider-component/dist-css/vue-slider-component.css';
import 'vue-slider-component/theme/default.css';

import debounce from 'lodash.debounce';

export default {
    props: {
        filters: VueTypes.array.required,
        priceFilter: VueTypes.object.def(null),

        sidebar: VueTypes.bool.def(false),
        isFarmacie: VueTypes.bool.def(false),
        isFarmacieSearch: VueTypes.bool.def(false),
        isBlocked: VueTypes.bool.def(false)
    },
    data() {
        return {
            activeFilterItem: null,

            activeStatusFilter: null,

            handledFilters: [],

            priceSlider: {
                range: [0, 2300],
                options: {
                    dotSize: 16,
                    width: '100%',
                    height: 6
                }
            },
            minMaxRangeValue: [],
            visibleFilters: []
        };
    },
    watch: {
        // '$i18n.locale': {
        //     async handler(e) {
        //         // console.log(this.activeParametersOptions, 'testets');
        //         // this.$emit('parameter-change');
        //         await this.$emit('update');
        //         // this.updateHandledFilters(this.filters);
        //     }
        // },
        filters(newVal, oldVal) {
            this.updateHandledFilters(newVal);
        },
        handledFilters: {
            handler(newVal, oldVal) {
                if (newVal.length && this.globalSettings.filter_display === 'vertical') {
                    this.activeFilterItem = newVal.reduce((acc, value, index) => {
                        acc[value.filterId] = true;
                        return acc;
                    }, {});
                }
            },
            deep: true,
            immediate: true
        },
        'priceSlider.range': debounce(function (newVal, oldVal) {
            console.log('232');
            this.setPage(1);
            this.SET_IS_RANGE_SLIDER_TRIGGERED(true);
            this.setPrice(newVal);
        }, 700)
    },
    computed: {
        ...mapGetters({
            globalSettings: 'global/globalSettings',
            activeParametersOptions: 'filters/activeParametersOptions',
            priceRange: 'filters/priceRange',
            statusFilter: 'filters/getStatusFilter'
        })
    },
    components: {
        VueSlider: () => import('vue-slider-component/dist-css/vue-slider-component.umd.min.js'),
        Price: () => import('@/components/helpers/Price'),
        MyFilterInput: () => import('@/components/ui/MyFilterInput'),
        FilterArrowMobile: () => import('@/components/svg/mobile/FilterArrowMobile')
    },
    methods: {
        ...mapMutations({
            SET_IS_RANGE_SLIDER_TRIGGERED: 'filters/SET_IS_RANGE_SLIDER_TRIGGERED',
            setPage: 'products/setPage'
        }),
        isParamActive(optionKey) {
            return this.activeFilterItem?.[optionKey] === true;
        },
        isParamOptionsActive(filterId) {
            return this.activeParametersOptions.find(p => p.type === filterId)?.options?.length ? true : false;
        },
        isOptionActive(optionKey, filterId) {
            const item = this.activeParametersOptions.find(p => p.type === filterId);
            return item?.options?.includes(optionKey) ? true : false;
        },
        isPriceParam(type) {
            return type === 'range' ? true : false;
        },
        updateHandledFilters(filtersList = []) {
            if (filtersList.length) {
                const seenIds = new Set();
                let newFilters = filtersList.filter(item => !seenIds.has(item.filterId) && seenIds.add(item.filterId));

                this.updateRangeSliders(this.priceFilter);

                this.handledFilters = newFilters;
            }
        },
        updateRangeSliders(priceData = this.priceFilter) {
            if (priceData) {
                this.priceSlider.range[0] = priceData.selectedFrom;
                this.priceSlider.range[1] = priceData.selectedTo;
            }
        },

        setActiveFilterItem(itemId) {
            if (this.activeFilterItem?.[itemId]) {
                this.activeFilterItem =
                    this.globalSettings.filter_display === 'horizontal'
                        ? {
                              [itemId]: false
                          }
                        : {
                              ...this.activeFilterItem,
                              [itemId]: false
                          };
            } else
                this.activeFilterItem =
                    this.globalSettings.filter_display === 'horizontal'
                        ? {
                              [itemId]: true
                          }
                        : {
                              ...this.activeFilterItem,
                              [itemId]: true
                          };
        },
        setParameter(optionKey, filterId, name) {
            let newActiveParams = [...this.activeParametersOptions];
            const paramModel = {
                type: filterId,
                options: []
            };
            const newParamModel = options => {
                return {
                    ...paramModel,
                    options: options,
                    name: name
                };
            };

            if (newActiveParams.find(np => np.type === filterId)) {
                newActiveParams = newActiveParams.map(p => {
                    const type = p.type;
                    const options = p.options;

                    if (type === filterId) {
                        if (options.includes(optionKey)) return newParamModel(options.filter(o => o !== optionKey));
                        else return newParamModel([...options, optionKey]);
                    } else return p;
                });
            } else {
                newActiveParams.push(newParamModel([optionKey]));
            }

            newActiveParams = newActiveParams.filter(p => p.options.length > 0);

            this.$store.dispatch('filters/setActiveParametersOptions', newActiveParams);

            this.$emit('parameter-change');
            this.$emit('update');
        },
        removeFilterByType() {
            this.$store.dispatch('filters/setActiveParametersOptions', []);
            this.$emit('parameter-change');
            this.$emit('update');
        },
        setPrice(newPriceRange) {
            const limitFrom = this.priceFilter.selectedFrom;
            const limitTo = this.priceFilter.selectedTo;
            const newFrom = newPriceRange[0];
            const newTo = newPriceRange[1];

            const limitCondtionFrom = newFrom >= limitFrom && newFrom <= limitTo;
            const limitCondtionTo = newTo >= limitFrom && newTo <= limitTo;

            if (limitCondtionFrom && limitCondtionTo) {
                this.$store.dispatch('filters/setPriceRange', [newFrom, newTo]);
                this.$emit('price-change');
                this.$emit('update');
            }
        },
        setFilterInputValue(idx, value) {
            const newRange = [this.priceSlider.range[0], this.priceSlider.range[1]];

            if (!value) {
                // this.setPrice(newRange);
                this.priceSlider.range = newRange;
                return;
            }

            const currentValue = this.priceSlider.range[idx];

            if (currentValue !== value) {
                newRange[idx] = value;
                this.priceSlider.range = newRange;
            }
        },
        getActiveFilters(filterId) {
            return this.activeParametersOptions.find(p => p.type === filterId)?.options[0];
        },
        displayedOptions(options, filterIndex) {
            const index = this.filters.findIndex((f, i) => i === filterIndex);
            return this.visibleFilters[index] ? options : options.slice(0, 5);
        },
        toggleFilterVisibility(filterIndex) {
            this.$set(this.visibleFilters, filterIndex, !this.visibleFilters[filterIndex]);
        }
    },
    mounted() {
        this.minMaxRangeValue = this?.priceSlider?.range;
    },
    beforeMount() {
        this.updateHandledFilters(this.filters);
    },
    beforeDestroy() {
        this.SET_IS_RANGE_SLIDER_TRIGGERED(false);
    }
};
